import { render, staticRenderFns } from "./caseList.vue?vue&type=template&id=b9b7921a&scoped=true&"
import script from "./caseList.vue?vue&type=script&lang=js&"
export * from "./caseList.vue?vue&type=script&lang=js&"
import style0 from "./caseList.vue?vue&type=style&index=0&id=b9b7921a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b7921a",
  null
  
)

export default component.exports